/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';
import { fetchWallet } from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useWallet() {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'wallet', userId, sessionId],
    queryFn: () => fetchWallet(getToken),
    enabled: Boolean(userId)
  });
}
